import { useRef, useEffect, useState } from 'react'
import { AgencyIcon } from "../helpers/AgencyIcon";
import { AgencySelect } from "../helpers/AgencySelect";

export const HeaderEdit = ({ data, updateAgency, fetching, setFetching, save, cancel }) => {

  const [ showFallback, setShowFallback ] = useState(false)
  const [ excluded, setExcluded ] = useState(tangibleFields.store.getValue('exclude_agencies'));
  const selectedAgency = useRef(data.agency ?? {})
  const fallbackInput = useRef(null)

  useEffect(() => {
    const handleRerender = tangibleFields.event( 'updateAgencyExclude', newExclude => { setExcluded(newExclude) })

    return () => {
      removeEventListener('tangible/fields/updateAgencyExclude', handleRerender)
    }
  }, [])

  useEffect(() => {
    if ( showFallback ) {
      const fallbackAgencyData = {
        "userFields": [],
        "licenseFields": [
          {
            "type": "license",
            "name": `accrediting_agency-${data.id}-fallback-license`,
            "label": "License Number",
            "regions": [],
            "professions": [],
            "value": "",
            "display_value": "",
            "renewal_date": ""
          }
        ],
        "enrolmentType": "automatic",
        "agencyLink": false
      }

      updateAgency(selectedAgency.current, fallbackAgencyData)
    }
  }, [showFallback])

  const fetchAgencyInfo = (agency) => {
    if ( fetching ) return
    setFetching(true)

    const ajax = window.Tangible.ajax
    ajax( 'tgbl_cred_get_agency_info', { user_id: data.userID, agency_id: agency.value })
      .then( result => {
        // console.log(result)
        updateAgency(agency, result)
        setFetching(false)
      })
      .catch( error => { console.error(error) })
  }

  const agencyOptions = tangibleFields.store.getValue('tgbl_agency_enrolment_settings').agencies
  const agencySelect = <AgencySelect
    // options={agencyOptions.filter(i => excluded.indexOf(i.value) === -1 || i.value === selectedAgency.current.value )}
    options={agencyOptions}
    disabledOptions={agencyOptions.reduce((acc, curr) => {
      if ( excluded.indexOf(curr.value) !== -1 || curr.value === selectedAgency.current.value ) acc.push(curr.value)
      return acc
    }, [])}
    onChange={res => {
      let newExclude = excluded.filter( i => i !== selectedAgency.current.value )
      if ( res ) {
        newExclude.push(res.value)
        selectedAgency.current = { ...res }
        fetchAgencyInfo(res)
      } else  {
        selectedAgency.current = {}
        updateAgency(null)
      }

      if ( JSON.stringify(newExclude) !== JSON.stringify(excluded) ) {
        tangibleFields.store.setValue('exclude_agencies', newExclude)
        tangibleFields.trigger( 'updateAgencyExclude', newExclude )
      }
    }}
    fallback={() => {
      // Update excluded agencies
      let newExclude = excluded.filter( i => i !== selectedAgency.current.value )
      tangibleFields.store.setValue('exclude_agencies', newExclude)
      tangibleFields.trigger( 'updateAgencyExclude', newExclude )

      selectedAgency.current = { value: null, label: '' }
      setShowFallback(true)
    }}
  />

  let icon, title
  if ( data.agency ) {
    let statusClass = data.enrolmentStatus
    if ( statusClass === 'approved' && data.licenseIncomplete ) statusClass = 'pending'
    if ( data.agency.value === null ) statusClass = 'new'

    icon = <span className={`tgbl-user-accrediting-agencies__list__item__status tgbl-user-accrediting-agencies__list__item__status--${statusClass}`}>
      <AgencyIcon type={ data.enrolmentStatus }/>
    </span>
    title = <div className="tgbl-user-accrediting-agencies__list__item__title">{ data.agency.label }</div>

  } else {
    icon = <span className="tgbl-user-accrediting-agencies__list__item__status tgbl-user-accrediting-agencies__list__item__status--new">
      <AgencyIcon type='edit-small'/>
    </span>
    title = <div className="tgbl-user-accrediting-agencies__list__item__header__form">
      { showFallback
        ? <input
          type="text"
          className={`accrediting_agency-${data.id}-fallback`}
          placeholder="Board Name"
          onChange={e => updateAgency({ value: null, label: e.target.value })}
          ref={fallbackInput}
        />
        // ? tangibleFields.render({
        //   type: 'text',
        //   name: `accrediting_agency-${data.id}-fallback`,
        //   label: 'Board Name',
        //   description: 'Please indicate the name of the board you’re licensed by'
        // })
        : agencySelect
      }
    </div>
  }

  return (
    <div className="tgbl-user-accrediting-agencies__list__item__header">
      { icon }
      { title }
      <div className="tgbl-user-accrediting-agencies__list__item__header__form__actions">
        {/* Save button */}
        <button
          className="tgbl-button tgbl-button--theme-primary" type="button"
          disabled={
            fetching ||
            selectedAgency.current.value === undefined ||
            ( fallbackInput.current && fallbackInput.current.value === '' )
          }
          onClick={save}
        >
          { fetching
            ? <>
              { data.agency === null ? 'Fetching' : 'Saving' }
              <div className="tgbl-button__spinner"/>
            </>
            : <>Save</>
          }
        </button>

        {/* Cancel button */}
        <button
          className="tgbl-button tgbl-button--theme-secondary cancel" type="button"
          disabled={fetching}
          onClick={cancel}
        >Cancel</button>
      </div>
    </div>
  )
}

